import React, { Component } from 'react'
import {
  Modal,
  ModalBackground,
  Delete,
  ModalCard,
  ModalCardBody,
  ModalCardFooter,
  ModalCardHeader,
  ModalCardTitle,
  Button,
  Field, Control, Input, Label, Help
} from 'bloomer'
import { Mutation } from 'react-apollo'
import { gql } from 'apollo-boost'

const CREATE_HOUSE = gql`
  mutation ($name: String!, $description: String!) {
    createHouse(name: $name, description: $description) {
      house { id, name, description }
    }
  }
`

const initialState = () => ({
  name: {
    value: '',
    error: null
  },
  description: {
    value: '',
    error: null
  },
  feedback: null
})

export default class CreateHouseModal extends Component {
  state = {
    ...initialState(this.props)
  }

  handleChange = (key) => (evt) => {
    const value = evt.target.value
    this.setState((state) => ({
      [key]: {
        ...state[key],
        value
      }
    }))
  }

  handleClose = (evt) => {
    this.setState(() => ({
      ...initialState(this.props)
    }))

    this.props.handleClose(evt)
  }

  handleSubmit = async (mutate, evt) => {
    evt.preventDefault()

    const { name } = this.state

    if (name.value.trim() === '') {
      this.setState((state) => ({
        name: {
          ...state.name,
          error: 'Informe um nome para a nova casa'
        }
      }))
      return
    }

    try {
      await mutate()
      this.props.refetch()
      this.props.handleClose(evt)
    } catch (e) {
      this.setState(() => ({
        feedback: 'Ocorreu um erro na comunicação com servidor'
      }))
      console.error(e)
    }
  }

  render() {
    const { name, description } = this.state
    const { isActive } = this.props

    return (
      <Modal isActive={isActive}>
        <ModalBackground onClick={this.handleClose}/>
        <Mutation mutation={CREATE_HOUSE} variables={{name: name.value, description: description.value}}>
          {(mutate, {loading}) => (
            <ModalCard tag="form" onSubmit={this.handleSubmit.bind(this, mutate)}>
              <ModalCardHeader>
                <ModalCardTitle>Criar casa</ModalCardTitle>
                <Delete onClick={this.handleClose} />
              </ModalCardHeader>
              <ModalCardBody>
                <Field>
                  <Control>
                    <Label>Nome</Label>
                    <Input type="text" placeholder="Escritório" isColor={name.error ? 'danger' : null} autoFocus onChange={this.handleChange('name').bind(this)} value={name.value} />
                    {name.error && <Help isColor="danger">{name.error}</Help>}
                  </Control>
                </Field>
                <Field>
                  <Control>
                    <Label>Descrição</Label>
                    <Input type="text" placeholder="Escritório no Edifício do Centro" maxLength="255" onChange={this.handleChange('description').bind(this)} value={description.value} />
                  </Control>
                </Field>
              </ModalCardBody>
              <ModalCardFooter>
                <Button type="submit" isLoading={loading} isColor="success">Criar</Button>
                <Button onClick={this.handleClose}>Cancelar</Button>
              </ModalCardFooter>
            </ModalCard>
          )}
        </Mutation>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/SwitchHousePage/modals/CreateHouseModal.js